import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Header from "../Header";
import { DataGrid } from '@mui/x-data-grid';
import { data, param } from 'jquery';
import { Button, Card, CardContent, Select, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Container from '@mui/material/Container';
import { MenuItem, TextField } from '@material-ui/core';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';



const rows = [
];

const id = {

    userId: window.localStorage.getItem("userID")
}




const Mybicycle = () => {


    const [bicycles, setState] = useState([]);
    const [dataGridRows, setDataGridRows] = useState([]);
    const [userData, setUserData] = useState([]);

    const [height, setHeight] = useState();
    const [weight, setWeight] = useState();
    const [skill, setSkill] = useState();
    const [discipline, setDiscipline] = useState();
    const [inseam, setInseam] = useState();
    const [reach, setReach] = useState();
    const [imperialMatric, setImperialMatric] = useState();






    const fetchData = async () => {
        axios.post(process.env.REACT_APP_BASE_URL + 'product/getBicycleForUser', id, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': window.localStorage.getItem("token")
            },
        }).then((response) => {
            if (response.status === 200) {


                console.log('res', response.data.bicycles)
                // rows = response.data.bicycles;

                // setState((prevState) => ({
                //     ...prevState,
                //     bicycles: response.data.bicycles,
                // }));


                response.data.bicycles.forEach((item) => {
                    console.log('res', item)
                    // rows.push(item);
                    setDataGridRows(dataGridRows => [...dataGridRows, item])
                })


            }
        }).catch((error) => {
            console.log('err', error);
        });
    }




    const handleDelete = (idToDelete) => {
        axios.post(
            process.env.REACT_APP_BASE_URL + 'product/deleteBicycleFromUser',
            {
                id: idToDelete

            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': window.localStorage.getItem("token")
                }
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    // If the deletion is successful, fetch the updated data

                    window.location.reload();
                    fetchData();


                }
            })
            .catch((error) => {
                console.log('err', error);
            });
    };

    const updateUser = (idToUpdateUser) => {
        axios.post(
            process.env.REACT_APP_BASE_URL + 'users/update-user',
            {
                id: idToUpdateUser,
                height: height,
                weight: weight,
                skill: skill,
                discipline: discipline,
                inseam: inseam,
                reach: reach,
                imperial_metric: imperialMatric

            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': window.localStorage.getItem("token")
                }
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    // If the deletion is successful, fetch the updated data

                    setUserData(response.data);
                    setHeight(response.data.height)
                    setWeight(response.data.weight)
                    setSkill(response.data.skill)
                    setDiscipline(response.data.discipline)
                    setInseam(response.data.inseam)
                    setReach(response.data.reach)
                    setImperialMatric(response.data.imperial_metric)

                }
            })
            .catch((error) => {
                console.log('err', error);
            });
    };


    const updateUserBicycle = (rowId) => {
        axios.post(
            process.env.REACT_APP_BASE_URL + 'product/updateBicycleForUser',
            {
                id: rowId
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': window.localStorage.getItem("token")
                }
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    console.log('updatebycle', response)
                }
            })
            .catch((error) => {
                console.log('err', error);
            });
    };






    useEffect(() => {
        fetchData();
        updateUser(window.localStorage.userID)




    }, []);


    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'make', headerName: 'Make', width: 130 },
        { field: 'model', headerName: 'model', width: 130 },
        { field: 'modelTrim', headerName: 'modelTrim', width: 90 },
        { field: 'userId', headerName: 'UserId', width: 160 },
        {
            field: 'delete',
            headerName: 'Delete',
            width: 100,
            renderCell: (params) => (
                <button onClick={
                    () => handleDelete(params.row.id)

                }>Delete</button>
            ),
        },
        {
            field: 'update',
            headerName: 'Update',
            width: 100,
            renderCell: (params) => (


                <Link to={`/edit-details/${params.row.year}/${params.row.make}/${(params.row.model).replace(/\s+/g, '_')}/${params.row.modelTrim}/${params.row.id}`}>
                    {console.log('aaaaaaa', params.row)}
                    <button>View</button>
                </Link>
            ),
        },
    ];




    const handleHeightChange = (e) => {
        const inputValue = e.target.value;

        // Check if the entered value is an integer or empty
        if (/^\d*$/.test(inputValue)) {
            // Parse the input value as an integer or set an empty string
            setHeight(inputValue === '' ? '' : parseInt(inputValue, 10));
        }
    };


    const handleWeightChange = (e) => {
        const inputValue = e.target.value;

        // Check if the entered value is an integer or empty
        if (/^\d*$/.test(inputValue)) {
            // Parse the input value as an integer or set an empty string
            setWeight(inputValue === '' ? '' : parseInt(inputValue, 10));
        }
    };


    const handleInseamChange = (e) => {
        const inputValue = e.target.value;


        if (/^\d*$/.test(inputValue)) {

            setInseam(inputValue === '' ? '' : parseInt(inputValue, 10));
        }
    };
    const handleReachChange = (e) => {
        const inputValue = e.target.value;


        if (/^\d*$/.test(inputValue)) {

            setReach(inputValue === '' ? '' : parseInt(inputValue, 10));
        }
    };


    const backgroundColorWithOpacity = 'rgba(0, 255, 255, 0.5)';

    return (
        <>

            <Header></Header>

            <Container>
                <div className='bicylces-details'>
                    <h3 style={{ marginBottom: '30px' }}>Saved Bicycles</h3>
                    <div className='bicycles-cart'>
                        {dataGridRows?.map((bicycle) => (
                            <Card key={bicycle.id} className='bicy' style={{ margin: '10px', width: '300px', backgroundColor: '#A7D8F7' }}>
                                <CardContent>
                                    <Typography variant="h6">{`${bicycle.make}`} {`${bicycle.model}`} {`${bicycle.modelTrim}`}</Typography>

                                    {/* Add more details if needed */}
                                    <Button onClick={() => handleDelete(bicycle.id)}>Delete</Button>
                                    <Link
                                        to={`/edit-details/${bicycle.year}/${bicycle.make}/${(bicycle.model).replace(/\s+/g, '_')}/${bicycle.modelTrim}/${bicycle.id}`}
                                    >
                                        <Button>View</Button>
                                    </Link>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                </div>

                {/* <div style={{ paddingTop: 50, margin: 'auto' }}>
                    <h3 style={{ marginBottom: '30px' }}>User Details</h3>
                </div> */}
            </Container>
            <Container>
                {/* <div style={{ paddingTop: 150, width: '100%' }}>
                    <h3 style={{ marginBottom: '30px' }}>Saved Bicycles</h3>
                    <DataGrid
                        style={{ margin: 'auto' }}
                        rows={dataGridRows}
                        columns={columns}
                        pagination={false} // Disable pagination control
                        hideFooterPagination={true}



                    />
                </div> */}

                <div style={{ paddingTop: 50, margin: 'auto' }}>
                    <h3 className='user-title' style={{ marginBottom: '30px' }}>User Details</h3>
                    <TableContainer className='user-table' component={Paper} >
                        <Table className='user-table-sub' style={{ width: '40%' }}>
                            <RadioGroup
                                row
                                style={{ marginLeft: '20px' }}
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={`${imperialMatric}`}

                            >
                                <FormControlLabel value="true" onChange={(e) => setImperialMatric(e.target.value)} control={<Radio size='small' />} label={<span style={{ fontSize: 'small' }}>Imperial</span>} />
                                <FormControlLabel value="false" onChange={(e) => setImperialMatric(e.target.value)} control={<Radio size='small' />} label={<span style={{ fontSize: 'small' }}>Metric</span>} />
                            </RadioGroup>

                            <TableBody>
                                <TableRow>
                                    <TableCell>Username</TableCell>
                                    <TableCell>{userData?.name == null ? 'no username' : userData?.name}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Email</TableCell>
                                    <TableCell>{userData?.email == null ? 'no email' : userData?.email}</TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>Height</TableCell>
                                    <TableCell>
                                        <TextField
                                            value={userData?.height === '' ? '' : height}
                                            onChange={handleHeightChange}
                                            placeholder="Enter integer value"
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Weight</TableCell>
                                    <TableCell>

                                        <TextField
                                            value={userData?.weight === '' ? '' : weight}
                                            onChange={handleWeightChange}
                                            placeholder="Enter integer value"
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Skill</TableCell>
                                    <TableCell>
                                        {/* <TextField value={userData?.skill === '' ? '' : skill} onChange={(e) => setSkill(e.target.value)} /> */}
                                        <Select
                                            style={{ paddingLeft: '5px', width: '120px' }}
                                            value={`${skill}`}
                                            onChange={(e) => setSkill(e.target.value)}
                                        >
                                            <MenuItem value="Beginner">Beginner</MenuItem>
                                            <MenuItem value="Intermediate">Intermediate</MenuItem>
                                            <MenuItem value="Expert">Expert</MenuItem>
                                            <MenuItem value="Pro">Pro</MenuItem>
                                        </Select>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Discipline</TableCell>
                                    <TableCell>
                                        {/* <TextField value={userData?.discipline === '' ? '' : discipline} onChange={(e) => setDiscipline(e.target.value)} /> */}
                                        <Typography variant="h6" >
                                            <Select
                                                style={{ paddingLeft: '10px', width: '100px' }}
                                                value={`${discipline}`}
                                                onChange={(e) => setDiscipline(e.target.value)}
                                            >
                                                <MenuItem value="downhill">Downhill</MenuItem>
                                                <MenuItem value="XC">XC</MenuItem>
                                                <MenuItem value="trail">Trail</MenuItem>
                                                <MenuItem value="fitness">Fitness</MenuItem>
                                                <MenuItem value="enduro">Enduro</MenuItem>
                                                <MenuItem value="DJ">DJ</MenuItem>
                                            </Select>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Inseam</TableCell>
                                    <TableCell>

                                        <TextField
                                            value={userData?.inseam === '' ? '' : inseam}
                                            onChange={handleInseamChange}
                                            placeholder="Enter integer value"
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Reach</TableCell>
                                    <TableCell>
                                        <TextField
                                            value={userData?.reach === '' ? '' : reach}
                                            onChange={handleReachChange}
                                            placeholder="Enter integer value"
                                        />
                                    </TableCell>
                                </TableRow>
                                {/* Add more rows for other properties */}
                            </TableBody>

                        </Table>

                    </TableContainer>

                    <div className='user-save'>
                        <Button
                            className='m-3'
                            variant="contained"
                            onClick={() => {
                                updateUser(window.localStorage.userID)
                            }}
                            style={{ backgroundColor: '#FB7619' }}
                        >
                            Save
                        </Button>

                    </div>

                </div>
            </Container>


        </>
    );
};

export default Mybicycle;
